import React, { useEffect, useState } from "react";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import Avatars from "./Avatar";
import StaticItem from "./StaticItem";
import { useDispatch, useSelector } from "react-redux";
import DocUpload from "./DocUpload";
import { addQueries, addQueryDocs, setCaseId } from "../Queries/redux/actions";
import { api } from "../../Services";
import ModalComponent from "./Modal";
import GradientLoader from "./Loader";

export default function BasicTimeline(props) {
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const queryDocs = useSelector((state) => state.queryDocs);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [qDocs, setQDocs] = useState([]);
  const [uploading, setUploading] = useState(false);

  const dispatch = useDispatch();
  const queries = useSelector((state) => state.queries.queries);

  async function callDocs() {
    console.log("in doc function", tokenData, queries);
    try {
      const docs2 = await api.getDocuments(
        "cases",
        // queries?.caseId,
        tokenData.appId,
        tokenData?.token
      );
      console.log("in docs api", docs2);
      setQDocs(docs2.data);
      dispatch(addQueryDocs(docs2.data));

      // setData(result);
      // dispatch(addQueries(result.data));
    } catch (error) {
      console.error("Error:", error);
    }
  }
  const showName = (name) => {
    let ext = name.split(".")[name.split(".")?.length - 1];
    name = name.replace(new RegExp("\\b" + ext + "\\b", "ig"), "");
    return (
      <div className="txt-div">
        <div className="txt-div-name">{name}</div>
        {ext}
      </div>
    );
  };
  const delDoc = async (id) => {
    try {
      setUploading(true);
      let item = {
        documentId: id,
      };
      const data = await api.deleteDocument(
        "cases",
        tokenData?.applicationData.id,
        tokenData?.token,
        item
      );
      setUploading(false);
      callDocs();
    } catch (err) {
      // alert("Sorry! Something went wrong, Please try again.");

      console.error("Error deleting document:", err);
      setUploading(false);
    }
  };
  useEffect(() => {
    callDocs();
  }, []);
  return (
    <Timeline>
      <TimelineItem>
        <TimelineSeparator>
          <Avatars />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <div className="time-line-data">
            <div className="data-top md-desc">
              <div className="data-left ">You</div>
              {/* <div className="data-right">Jan 12, 2024</div> */}
            </div>
            <div className="data-btm">
              <div className="data-title md-desc">
                {props.item.caseCategory}
              </div>
              <div className="data-desc sub-option-text">
                {props.item.caseDetails}
              </div>
              <div>
                {qDocs[props.item.id]?.map((item, index) => {
                  return (
                    <div className="doc-col" item={index}>
                      <div className="doc-item">
                        <StaticItem
                          onChange={() => {}}
                          onDelete={() => delDoc(item?.id)}
                          type={"doc"}
                          // isEditable={true}
                          title={item.type}
                          doc={item}
                          docUrl={item.documentUrl}
                          value={item.name}
                          size={Math.floor(item.size / 1024)}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* {props.item.caseDocument  && */}
              {/* <div className="doc-item">
                <StaticItem
                  type={"doc"}
                  title={""}
                  value={showName("9831009988.svg")}
                />
              </div> */}
              {/* } */}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      {props?.item?.studentCaseQueries?.map((item, index) => {
        return (
          <TimelineItem
            key={index}
            className={` ${item.userType === "HELPDESK" && "help-item"}`}
          >
            <TimelineSeparator>
              <Avatars />
              {props?.item?.studentCaseQueries?.length !== index + 1 && (
                <TimelineConnector />
              )}
            </TimelineSeparator>
            <TimelineContent>
              <div className="time-line-data">
                <div className="data-top md-desc">
                  <div className="data-left ">{item?.userType}</div>
                  <div className="data-right">{item?.createdAt}</div>
                </div>
                <div className="data-btm">
                  <div className="data-desc sub-option-text">
                    {item.comment}
                  </div>
                </div>
              </div>
            </TimelineContent>
          </TimelineItem>
        );
      })}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </Timeline>
  );
}
